<template>
  <div
    class="animated fadeIn uni-faculty main-div"
    :class="uniInfo.isDistinguished ? 'distinguished-class' : ''"
  >
    <vLoading v-if="vLoading" />
    <div v-if="pageLoaded">
      <v-row class="pt-1">
        <v-col sm="6" cols="12">
          <div class="pt-1 fs-small">
            <router-link to="/map" class="no-underline">
              <span class="c-primary"> انتخاب استان </span>
            </router-link>
            <v-icon>mdi-chevron-left</v-icon>
            <span @click="goToMap('state')" class="c-grey pointer">
              استان {{ uniInfo.state }}
            </span>
            <v-icon>mdi-chevron-left</v-icon>
            <span @click="goToMap('university')" class="c-grey pointer">
              دانشگاه‌ها
            </span>
            <v-icon>mdi-chevron-left</v-icon>
            <span @click="goToProfile()" class="c-grey pointer">
              {{ uniInfo.name }}
            </span>
            <v-icon>mdi-chevron-left</v-icon>
            <span class="c-grey font-weight-bold"> هیئت علمی </span>
          </div>
        </v-col>
        <v-col class="text-left" sm="6" cols="12">
          <v-btn
            @click="goToMap('state')"
            :class="uniInfo.isDistinguished ? 'toMap-btn' : ''"
            class="bc-primary text-white no-underline"
            ><span class="c-light">بازگشت به نقشه</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row class="mb-1">
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <v-card class="common-card uni-card">
            <v-row class="uni-header">
              <div class="view-imageBox">
                <img
                  :src="
                    uniInfo.avatar
                      ? uniInfo.avatar
                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                  "
                />
              </div>
              <div class="description-box px-5 pl-0">
                <div class="d-flex">
                  <img
                    v-if="uniInfo.isDistinguished"
                    class="star-icon me-2"
                    src="/icon-star.png"
                  />
                  <h5 class="mt-3 c-dark fs-xxlarge">
                    {{ uniInfo.name }}
                  </h5>
                </div>
                <p
                  v-if="uniInfo.description"
                  class="c-grey fs-medium text-justify"
                >
                  {{
                    uniInfo.description.length > 180
                      ? uniInfo.description.slice(0, 180) + "..."
                      : uniInfo.description
                  }}
                </p>
                <p v-else class="c-grey fs-small">
                  توضیحی برای دانشگاه ثبت نشده است.
                </p>
              </div>
            </v-row>
            <div v-if="uniInfo.description.length > 220" class="text-left">
              <v-btn
                class="seeMore-btn"
                @click="openSeeMoreModal('description')"
                text
              >
                <span class="c-primary">مشاهده بیشتر</span>
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <v-card class="common-card card-height">
            <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس دانشگاه</h5>
            <div class="pt-2 c-grey">
              <v-icon class="pe-2">$Location</v-icon>
              <span class="fs-medium">
                نشانی دانشگاه:
                {{
                  uniInfo.state +
                  ", " +
                  uniInfo.city +
                  (uniInfo.city ? ", " : "")
                }}{{ uniInfo.address ? uniInfo.address : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2">$Phone</v-icon>
              <span class="fs-medium">
                تلفن‌های تماس روابط عمومی:
                {{ uniInfo.tel ? uniInfo.tel : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2">$Email</v-icon>
              <span class="fs-medium">
                کدپستی: {{ uniInfo.postalCode ? uniInfo.postalCode : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2">$Url</v-icon>
              <span class="fs-medium" v-if="uniInfo.website">
                آدرس‌‌ تارنما:
                <a :href="checkWebsite()" target="_blank">{{
                  uniInfo.website
                }}</a>
              </span>
              <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-card class="common-card">
        <v-row>
          <v-col lg="4" cols="12" class="py-0">
            <v-card class="common-card card-height px-3">
              <v-row>
                <v-col cols="9" class="py-0">
                  <h5 class="mb-0 mt-1">کل اعضای هیئت علمی:</h5>
                </v-col>
                <v-col class="text-left py-0">
                  <h5 class="mb-0 mt-1 float-end">
                    {{ uniInfo.scienceCommitteeCounts }} نفر
                  </h5>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-divider class="d-lg-block d-none" vertical></v-divider>
          <v-col lg="4" cols="12" class="py-0">
            <v-card class="common-card card-height px-3">
              <v-row>
                <v-col cols="9" class="py-0">
                  <h5 class="mb-0 mt-1">
                    اعضای هیئت علمی مرتبط با زیست فناوری:
                  </h5>
                </v-col>
                <v-col class="text-left py-0">
                  <h5 class="mb-0 mt-1 float-end">
                    {{ uniInfo.bioScienceCommitteeCounts }} نفر
                  </h5>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-divider class="d-lg-block d-none" vertical></v-divider>
          <v-col lg="4" cols="12" class="py-0">
            <v-card class="common-card card-height px-3">
              <v-row>
                <v-col cols="9" class="py-0">
                  <h5 class="mb-0 mt-1">
                    اعضای هیئت علمی تعریف شده در سامانه:
                  </h5>
                </v-col>
                <v-col class="text-left py-0">
                  <h5 class="mb-0 mt-1 float-end">
                    {{ uniInfo.scienceCommitteeNo }} نفر
                  </h5>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <div class="mt-4">
        <v-card class="common-card card-height">
          <v-row class="pb-4">
            <v-col class="pb-0">
              <h4 class="mt-3">اعضای هیئت علمی</h4>
            </v-col>
            <v-col sm="5" cols="12" class="pb-0">
              <v-text-field
                rounded
                filled
                class="search-box mt-2 mt-sm-0"
                placeholder="جستجو در نام اعضا..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col v-if="!uniInfo.scienceCommittee.length">
              <div class="no-content">
                <hr />
                عضوی به ثبت نرسیده است.
                <hr />
              </div>
            </v-col>
            <v-col v-else>
              <div v-if="computedMembers.length">
                <v-row>
                  <v-col
                    v-for="(item, index) in computedMembers"
                    :key="index"
                    lg="3"
                    md="4"
                    sm="6"
                    cols="12"
                  >
                    <v-card
                      flat
                      class="members-card mx-auto"
                      :style="
                        uniInfo.isDistinguished
                          ? 'background-color:#46484f !important'
                          : 'background-color:#fff'
                      "
                    >
                      <div class="image-box">
                        <v-img
                          :src="
                            item.avatar
                              ? item.avatar
                              : 'https://bigbangram.com/theme/img/noavatar.png'
                          "
                        >
                        </v-img>
                      </div>
                      <div class="text-center mt-4">
                        <p class="fs-large c-dark">{{ item.name }}</p>
                        <p class="c-grey mt-4">{{ item.degree }}</p>
                        <p class="c-grey mt-4">{{ item.email }}</p>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <hr />
                <div class="text-center">موردی یافت نشد</div>
                <hr />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="seeMoreModal" width="600">
      <v-card
        class="modal-card"
        :class="uniInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">{{ uniInfo.name }}</h5>
            </v-col>
            <v-col class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p class="c-grey fs-medium text-justify" style="line-height: 30px">
            {{ uniInfo.description }}
          </p>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      facultyMembers: [],
      filter: "",
      uniInfo: {
        logoSrc: "",
        description: "",
        contactInfo: {
          address: "",
          phoneNumber: "",
          zipCode: "",
          url: "",
        },
      },
      seeMoreModal: false,
      vLoading: false,
      pageLoaded: false,
    };
  },
  methods: {
    openSeeMoreModal() {
      this.seeMoreModal = true;
    },
    goToMap(to) {
      this.$router.push("/map");
      if (to == "state") {
        localStorage.setItem("state", this.uniInfo.state);
        localStorage.setItem("stateId", this.uniInfo.stateId);
      } else if (to == "university") {
        localStorage.setItem("state", this.uniInfo.state);
        localStorage.setItem("stateId", this.uniInfo.stateId);
        localStorage.setItem("item", "university");
      }
    },
    goToProfile() {
      this.$router.go(-1);
    },
    getInfo() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/university/scienceCommittees",
          {
            universityId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.uniInfo = res.data;
          this.vLoading = false;
          this.pageLoaded = true;
        })
        .catch((err) => {
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    checkWebsite() {
      if (
        this.uniInfo.website.indexOf("http://") == 0 ||
        this.uniInfo.website.indexOf("https://") == 0
      ) {
        return this.uniInfo.website;
      } else {
        return "//" + this.uniInfo.website;
      }
    },
  },
  computed: {
    computedMembers() {
      let filtered;
      filtered = this.uniInfo.scienceCommittee.filter((x) =>
        x.name.includes(this.filter)
      );
      return filtered;
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
